export function formatShortDate(value: string | Date): string {
  const date = new Date(value);
  const day = date.toLocaleDateString('en-GB', { day: '2-digit' });
  const month = date.toLocaleDateString('en-GB', { month: 'short' });
  return `${day} ${month}, ${date.getFullYear()}`;
}
